(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pa-professional"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('.pa-pro [data-pro-action="advice"]');
  if (!link) return;
  const root = link.closest('.pa-pro');
  const form = root.querySelector('.pa-pro__form');
  if (!form) return;
  event.preventDefault();
  const interest = form.querySelector('select[name="contact[Interest]"]');
  if (interest && link.dataset.proInterest) interest.value = link.dataset.proInterest;
  const name = form.querySelector('input[name="contact[name]"]');
  form.scrollIntoView({ block: 'start', behavior: 'instant' });
  if (name) name.focus({ preventScroll: true });
});

  } catch(e) { console.error(e); }
})();
})();
